module.exports = __webpack_public_path__ + "img/sec11desk.f08bc71f.png";